import React from 'react';

import { Input, ButtonGroup, ImageGroup, FragranceGroup, ColourGroup } from '../components/Form';
import { FragranceScreen, ColourScreen } from '../components/Screens';

import { goalValidator } from './validators';

const products = window.quizData.products;

// The quiz steps, questions and options.
export default [
  {
    name: 'Product type',
    steps: [
      {
        heading: 'What combination of products do you want to buy?',
        autoSubmit: true,
        field: {
          component: ButtonGroup,
          options: [
            { value: products.SHAMPOO_AND_CONDITIONER.label },
            { value: products.SHAMPOO.label },
            { value: products.CONDITIONER.label },
          ],
          cols: 1,
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <p>
              Explain why
            </p>
          ),
        },
      }
    ]
  },
  {
    name: 'Your Details',
    steps: [
      {
        heading: 'What should we call you?',
        autoSubmit: false,
        field: {
          component: Input,
          label: 'Enter your first name...',
          rules: ['required', 'alpha'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <p>
              Now that we're getting to know each other, we'd like to know what we should call you. If you'd prefer, you
              can enter a nickname or pseudonym.
            </p>
          ),
        },
      },
      {
        heading: 'Nice to meet you, {{ whatShouldWeCallYou }}! How old are you?',
        field: {
          name: 'How old are you?',
          component: ButtonGroup,
          options: [
            { value: 'Under 20' },
            { value: 'In my 20s' },
            { value: 'In my 30s' },
            { value: 'In my 40s' },
            { value: 'In my 50s' },
            { value: 'In my 60s' },
            { value: '70 or over' },
            { value: 'Prefer not to say' },
          ],
          cols: 2,
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>
                We use this information to understand who our customers are and what we can do to make our products
                better for them.
              </p>
              <p>
                Don't feel like sharing? That's totally fine (we get it)! You can skip the question by selecting the
                'Prefer not to say' option.
              </p>
            </>
          ),
        },
      },
      {
        heading: "What's your gender?",
        field: {
          component: ButtonGroup,
          options: [{ value: 'Female' }, { value: 'Male' }, { value: 'Other' }, { value: 'Prefer not to say' }],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>
                We use this information to understand who our customers are and what we can do to make our products
                better for them.
              </p>
              <p>
                Don't feel like sharing? That's totally fine (we get it)! You can skip the question by selecting the
                'Prefer not to say' option.
              </p>
            </>
          ),
        },
      },
    ],
  },
  {
    name: 'Your Hair and Scalp',
    steps: [
      {
        heading: 'How long is your hair?',
        subHeading: 'If your hair is curly, pull it down to find its true length.',
        field: {
          component: ImageGroup,
          options: [
            { value: 'Short', svg: 'length-short', description: 'Buzz cut to the bottom of the ears' },
            { value: 'Chin length', svg: 'length-chin', description: "Doesn't touch the shoulders" },
            { value: 'Shoulder length', svg: 'length-shoulder', description: 'Sits on or slightly past the shoulders' },
            { value: 'Long', svg: 'length-long', description: 'Bottom of the shoulder blades or beyond' },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>Different hair lengths respond best to different fomulations.</p>
              <p>
                Want to know more? Cosmetic chemistry is complicated and there are too many factors to discuss here in
                full, but we'll give you an example. The longer hair is, the more likely it is to accumulate dirt, oils
                and damage. Stronger cleaning and conditioning ingredients can help to effectively clean and repair long
                hair without needing to use heaps of shampoo and conditioner.
              </p>
            </>
          ),
        },
      },
      {
        heading: "What's your hair's natural texture?",
        subHeading: "If your hair is textually treated, try to think back to when it wasn't.",
        field: {
          component: ImageGroup,
          options: [
            { value: 'Straight', svg: 'texture-straight', description: '1A, 1B and 1C' },
            { value: 'Wavy', svg: 'texture-wavy', description: '2A, 2B and 2C' },
            { value: 'Curly', svg: 'texture-curly', description: '3A, 3B and 3C' },
            { value: 'Coily', svg: 'texture-coily', description: '4A, 4B and 4C' },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>Different hair textures respond best to different formulations.</p>
              <p>
                Want to know more? Cosmetic chemistry is complicated and there are too many factors to discuss here in
                full, but we'll give you an example. Natural oils produced by the scalp travel easier through straight
                hair than curlier hair types. People with straight hair often struggle with oiliness and a lack of
                volume whilst people with curlier hair types often struggle with dryness and manageability. Cleaning and
                conditioning ingredients must be chosen carefully to optimise for each type of hair texture.
              </p>
            </>
          ),
        },
      },
      {
        heading: 'How dense is your hair?',
        subHeading: 'Part your hair and look in the mirror. The less scalp you see, the denser your hair is.',
        field: {
          component: ImageGroup,
          options: [
            { value: 'Not very dense', svg: 'density-not-very', description: "There's a significant part" },
            { value: 'Medium', svg: 'density-medium', description: "There's a little bit of scalp" },
            { value: 'Dense', svg: 'density-very', description: "There's very little to no scalp" },
            {
              value: "I'm not sure",
              svg: 'density-not-sure',
              description: "It's hard to tell or I can't be bothered checking",
            },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>Different hair densities respond best to different formulations.</p>
              <p>
                Want to know more? Cosmetic chemistry is complicated and there are too many factors to discuss here in
                full, but we'll give you a couple of examples. Hair that's not very dense is susceptible to being
                'weighed down' by product and can often lack volume. Lighter conditioning ingredients can be used to
                improve this hair type's features whilst also maximising its volume. On the other hand, dense hair is
                less susceptible to being weighed down but is often hard to manage. This type of hair is better at
                tolerating heavier conditioning ingredients which can tame frizz, flyaways and make it easier to
                control.
              </p>
            </>
          ),
        },
      },
      {
        heading: 'How thick are your hair strands?',
        subHeading: 'Roll a single strand of hair between your fingers.',
        field: {
          component: ImageGroup,
          options: [
            { value: 'Thin', svg: 'thickness-thin', description: 'I barely feel it' },
            { value: 'Medium', svg: 'thickness-medium', description: 'I feel it slightly' },
            { value: 'Thick', svg: 'thickness-thick', description: 'It feels about as thick as a sewing thread' },
            {
              value: "I'm not sure",
              svg: 'thickness-not-sure',
              description: "It's hard to tell or I can't be bothered checking",
            },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>Different hair strand thicknesses respond best to different formulations.</p>
              <p>
                Want to know more? Cosmetic chemistry is complicated and there are too many factors to discuss here in
                full, but we'll give you a couple of examples. Thin-stranded hair is susceptible to being 'weighed down'
                by product and can often lack volume (especially when it isn't very dense). Lighter conditioning
                ingredients can be used to improve this hair type's features whilst also maximising its volume. On the
                other hand, thick-stranded hair is less susceptible to being weighed down but is often hard to manage
                (especially when it is very dense). This type of hair is better at tolerating heavier conditioning
                ingredients which can tame frizz, flyaways and make it easier to control.
              </p>
            </>
          ),
        },
      },
      {
        heading: 'Generally speaking, is your hair dry or oily?',
        subHeading:
          'This may change at different times depending on the weather and other factors, but try to think about which option best describes your hair.',
        field: {
          component: ButtonGroup,
          options: [
            {
              value: 'Dry',
              description: "The roots don't get oily quickly and the ends are usually dry or frizzy",
              wide: true,
            },
            {
              value: 'Balanced',
              description: "The roots don't get oily quickly and the ends are usually balanced",
              wide: true,
            },
            {
              value: 'Mixed',
              description: 'The roots get oily quickly but the ends are usually dry or frizzy',
              wide: true,
            },
            {
              value: 'Oily',
              description: 'The roots get oily quickly and the ends are usually balanced or oily',
              wide: true,
            },
          ],
          extraClass: 'form-2-col',
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>Dry and oily hair respond best to different formulations.</p>
              <p>
                Want to know more? Cosmetic chemistry is complicated and there are too many factors to discuss here in
                full, but we'll give you a couple of examples. Stronger and/or more concentrated cleaning ingredients
                can help to clean oily hair effectively, without using heaps of shampoo or needing to rewash several
                times. On the other hand, weaker and less concentrated cleaning ingredients can help to clean dry hair
                effectively, without stripping away unnecessary amounts of natural oils that help to make hair feel less
                dry.
              </p>
            </>
          ),
        },
      },
      {
        heading: 'How often do you wash your hair?',
        subHeading: 'This includes shampooing and co-washing.',
        field: {
          component: ButtonGroup,
          options: [
            { value: 'Every day' },
            { value: 'Every 2-3 days' },
            { value: 'Once a week' },
            { value: 'Less than once a week' },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>Dry and oily hair respond best to different formulations.</p>
              <p>
                Want to know more? Cosmetic chemistry is complicated and there are too many factors to discuss here in
                full, but we'll give you an example. If you wash your hair regularly, it may be better to use gentler
                cleaning ingredients. This depends on several other factors though, so we'll make these considerations
                in the context of the other information you've shared.
              </p>
            </>
          ),
        },
      },
      {
        heading: 'After washing your hair, how long until it gets oily again?',
        subHeading:
          'This may change at different times depending on the weather and other factors, but try to think about which option best describes your hair as of late.',
        field: {
          component: ButtonGroup,
          options: [
            { value: 'The same day' },
            { value: 'The next day' },
            { value: 'Two or more days' },
            { value: "I'm not sure" },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <>
              <p>Dry and oily hair respond best to different formulations.</p>
              <p>
                Want to know more? Cosmetic chemistry is complicated and there are too many factors to discuss here in
                full, but we'll give you an example. Stronger and/or more concentrated cleaning ingredients can help to
                clean oily hair effectively, without using heaps of shampoo or needing to rewash several times. On the
                other hand, weaker and/or less concentrated cleaning ingredients can help to clean dry hair effectively,
                without stripping away unnecessary amounts of natural oils that help to make hair feel less dry.
              </p>
            </>
          ),
        },
      },
      {
        heading: 'Do you notice your hair retaining odours?',
        subHeading: 'This includes odours from food, smoke, sweat and other sources.',
        field: {
          component: ButtonGroup,
          options: [{ value: 'Very rarely or never' }, { value: 'Here and there' }, { value: 'Yes, quite often' }],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <p>
              We all have different lifestyles which means our hair is exposed to a variety of different environmental
              conditions. If your hair is retaining odours, it may not be getting effectively cleaned and could benefit
              from stronger and/or more concentrated cleaning ingredients. If you're often noticing that your hair is
              retaining odours, you may also want to choose our strong fragrance option, which can help to mask odours
              for longer.
            </p>
          ),
        },
      },
      {
        heading: 'Is your scalp sensitive?',
        subHeading: 'This includes burning, dryness, itching, pain and tightness.',
        field: {
          component: ButtonGroup,
          options: [
            { value: 'Not at all' },
            { value: 'Every so often' },
            { value: 'Quite often' },
            { value: 'Always' },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Why do we ask?',
          body: (
            <p>
              Want to know more? Cosmetic chemistry is complicated and there are too many factors to discuss here in
              full, but we'll give you an example. Sensitive scalps usually respond best to 'gentle' formulations. If
              you've got a particularly sensitive scalp, we recommend you choose our no fragrance and no colour options.
              Fragrances and colourings are unfortunately common culprits for irritation.
            </p>
          ),
        },
      },
    ],
  },
  {
    name: 'Your Goals',
    steps: [
      {
        heading: 'Choose up to three hair goals.',
        subHeading: "We'll add science-backed ingredients to your formulas to help with your goals.",
        extraClass: 'fullwidth hair-goals info-mobile-only',
        info: {
          title: null,
          description: 'Click on a goal above and learn more about it here.',
        },
        autoSubmit: false,
        field: {
          component: ButtonGroup,
          cols: 6,
          colsExtraClass:'col-xs-6 col-md-4 col-lg-3 col-xl-2',
          descriptionExtraClass: 'd-none d-md-block',
          options: [
            {
              value: 'Hydrate and replenish',
              description: "Non-comedogenic argan and hemp seed oils moisturise the hair and a specialised polymer restores the hair's hydrophobic layer, preventing further damage caused by repeated swelling from water absorption.",
              info: "Non-comedogenic argan and hemp seed oils moisturise the hair and a specialised polymer restores the hair's hydrophobic layer, preventing further damage caused by repeated swelling from water absorption."
            },
            {
              value: 'Deep condition',
              description: 'An anti-static additive coats the hair, improving manageability and imparting softness, silkiness and shine. This is especially helpful for wavy, curly, coily, coarse, dry and damaged hair types.',
              info: 'An anti-static additive coats the hair, improving manageability and imparting softness, silkiness and shine. This is especially helpful for wavy, curly, coily, coarse, dry and damaged hair types.',
            },
            {
              value: 'Soothe scalp',
              description: 'Specialised cleansing and moisturising ingredients relieve discomfort and reduce flakiness caused by dandruff and/or dry scalp. ',
              info: 'Specialised cleansing and moisturising ingredients relieve discomfort and reduce flakiness caused by dandruff and/or dry scalp. ',
            },
            {
              value: 'Strengthen',
              description: 'Sugar-derived molecules penetrate deep into the cortex, fixing broken bonds and reinforcing the keratin structure. A non-volatile and safe silicone forms a film over the hair, reducing friction to minimise damage caused by styling.',
              info: 'Sugar-derived molecules penetrate deep into the cortex, fixing broken bonds and reinforcing the keratin structure. A non-volatile and safe silicone forms a film over the hair, reducing friction to minimise damage caused by styling.',
            },
            {
              value: 'Repair split ends',
              description: 'A guar-gum derivative bonds to irregularities on the damaged hair surface, holding down raised cuticles and working to seal split ends.',
              info: 'A guar-gum derivative bonds to irregularities on the damaged hair surface, holding down raised cuticles and working to seal split ends.',
            },
            {
              value: 'Reduce frizziness',
              description: "A guar-gum derivative repairs the hair's hydrophobic layer, reducing warping caused by repeated water absorption. A safe silicone synergistically fights against frizziness caused by humidity and styling damage.",
              info: "A guar-gum derivative repairs the hair's hydrophobic layer, reducing warping caused by repeated water absorption. A safe silicone synergistically fights against frizziness caused by humidity and styling damage.",
            },
            {
              value: 'Oil control',
              description: "Strong cleaning ingredients control oil whilst lighter conditioning ingredients make the hair less susceptible to being 'weighed down' and looking greasy.",
              info: "Strong cleaning ingredients control oil whilst lighter conditioning ingredients make the hair less susceptible to being 'weighed down' and looking greasy.",
            },
            {
              value: 'Thermal protection',
              description: 'A heat-dispersing ingredient coats the hair, reducing damage caused by the uneven distribution of heat during straightening, curling, etc.',
              info: 'A heat-dispersing ingredient coats the hair, reducing damage caused by the uneven distribution of heat during straightening, curling, etc.',
            },
            {
              value: 'UV protection',
              description: "The hair's surface is treated in a UV-absorptive ingredient which significantly reduces lipid peroxidation and protein degradation caused by exposure to sunlight.",
              info: "The hair's surface is treated in a UV-absorptive ingredient which significantly reduces lipid peroxidation and protein degradation caused by exposure to sunlight.",
              // info: "PLEASE NOTE: due to the nature of shampoo and conditioner formulations, chemical sunscreens need to be used instead of (generally preferable) physical sunscreens. We've chosen to use octisalate, which has less safety concerns and is more effective than other, more commonly used, chemical sunscreens. Whilst there is no evidence to suggest that octisalate is unsafe, some studies have concluded that it can be an allergen and absorbs through the skin in small amounts. We'd recommend selecting this goal if your hair gets heaps of sun exposure, but we urge you to make your own decision. If you're particularly sensitive, or feel uncomfortable with chemical sunscreens, give it a miss!",
            },
            {
              value: 'Colour retention',
              description: 'A specialised polymer coats dyed hair, sealing in the pigments to noticeably slow the fading process.',
              info: 'A specialised polymer coats dyed hair, sealing in the pigments to noticeably slow the fading process.',
            },
            {
              value: 'Increase shine',
              description: 'Non-volatile and safe silicones form a thin and even film over the hair, reflecting light to increase shine.',
              info: 'Non-volatile and safe silicones form a thin and even film over the hair, reflecting light to increase shine.',
            },
            {
              value: 'Volumise',
              description: 'A hyperbranched polymer forms spherical deposits on the surface of the hair, increasing the space between strands to provide noticeably more volume.',
              info: 'A hyperbranched polymer forms spherical deposits on the surface of the hair, increasing the space between strands to provide noticeably more volume.',
            },
            {
              value: 'Reduce brassiness for blondes',
              description: 'Purple pigment counteracts unwanted yellow tones.',
              info: 'Purple pigment counteracts unwanted yellow tones.',
            },
            {
              value: 'Reduce brassiness for brunettes',
              description: 'Blue pigment counteracts unwanted orange tones.',
              info: 'Blue pigment counteracts unwanted orange tones.',
            },
          ],
          multi: true,
          errorInModal: true,
          onErrorClose: (field, onOptionChange) => {
            const { onChange, value } = field;

            let newValues = value.filter(v => v !== 'Reduce brassiness for brunettes');

            if (newValues.length >= 4) {
              newValues = newValues.slice(0, 3);
            }

            // force select first option
            if(newValues.length == 0){
              newValues = ["Hydrate and replenish"];
            }

            onChange(newValues);
            onOptionChange(newValues);

          },
          rules: [{ validate: goalValidator }],
        },
        onNext: (state, setValue) => {
          const {
            chooseUpToThreeHairGoals: goals = [],
            whatColourDoYouWantYourShampooToBe: shampoo = null,
            whatColourDoYouWantYourConditionerToBe: conditioner = null,
          } = state;

          if (goals.length === 0) {
            return state;
          }

          const brassinessGoal = goals.findIndex(goal => goal.includes('Reduce brassiness')) > -1;

          if (!brassinessGoal) {
            let hasChanged = false;
            let newShampoo = shampoo;
            let newConditioner = conditioner;

            if (shampoo === 'Brassiness pigment') {
              hasChanged = true;
              newShampoo = null;
            }

            if (conditioner === 'Brassiness pigment') {
              hasChanged = true;
              newConditioner = null;
            }

            if (hasChanged) {
              setValue('whatColourDoYouWantYourShampooToBe', newShampoo);
              setValue('whatColourDoYouWantYourConditionerToBe', newConditioner);

              return {
                ...state,
                highestStep: 3, // Colour step
                whatColourDoYouWantYourShampooToBe: newShampoo,
                whatColourDoYouWantYourConditionerToBe: newConditioner,
              };
            }

            return state;
          }

          setValue('whatColourDoYouWantYourShampooToBe', 'Brassiness pigment');
          setValue('whatColourDoYouWantYourConditionerToBe', 'Brassiness pigment');

          return {
            ...state,
            whatColourDoYouWantYourShampooToBe: 'Brassiness pigment',
            whatColourDoYouWantYourConditionerToBe: 'Brassiness pigment',
          };
        },
      },
    ],
  },
  {
    name: 'Fragrance and Colour',
    steps: [
      {
        heading: 'What do you want your shampoo to smell like?',
        screen: FragranceScreen,
        extraClass: 'fullwidth',
        // info: {
        //   title: null,
        //   description: 'Click on a fragrance above and learn more about it here.',
        // },
        autoSubmit: false,
        field: {
          component: FragranceGroup,
          extraClass: 'fragrance-and-colour',
          options: [
            {
              value: 'No fragrance',
              description: "We won't add fragrance to your formulations, but that doesn't mean they will smell like nothing. The other ingredients have a fairly mild smell most find inoffensive.",
              sensitive: true,
              // info: {
              //   title: null,
              //   description:
              //     "We won't add fragrance to your formulations, but that doesn't mean they will smell like nothing. The other ingredients have a fairly mild smell most find inoffensive.",
              // },
            },
            {
              value: 'Peony and suede',
              description:'Luxurious and sensual. Floral peony, rose and jasmine mix with subtle notes of fuji apple, honeydew, musk and amber.',
              // info: {
              //   title: 'Luxurious and sensual',
              //   description:'Floral peony, rose and jasmine mix with subtle notes of fuji apple, honeydew, musk and amber.',
              // },
            },
            {
              value: 'Florals',
              description: 'A tribute to all things floral. Gardenia, cyclamen and frangipani mix with subtle notes of balsam, rosewood and jasmine.',
              // info: {
              //   title: 'A tribute to all things floral',
              //   description: 'Gardenia, cyclamen and frangipani mix with subtle notes of balsam, rosewood and jasmine.',
              // },
            },
            {
              value: 'Soft florals and sweet vanilla',
              description: 'Clean and smooth. Floral rose, jasmine and hawthorn mix with sweet notes of vanilla and musk on a woody base.',
              popular: true,
              // info: {
              //   title: 'Clean and smooth',
              //   description: 'Floral rose, jasmine and hawthorn mix with sweet notes of vanilla and musk on a woody base.',
              // },
            },
            {
              value: 'Blackberry and strawberry',
              description: 'Fruity yet rich and compelling. Blackberry and strawberry mix with apple, peony and white jasmine on a base of vanilla bean and precious woods.',
              popular: true,
              // info: {
              //   title: 'Fruity yet rich and compelling',
              //   description: 'Blackberry and strawberry mix with apple, peony and white jasmine on a base of vanilla bean and precious woods.',
              // },
            },
            {
              value: 'Lime and sandalwood',
              description: 'Simple and uplifting. Zesty lime sits on a sublime grounding of sandalwood.',
              // info: {
              //   title: 'Simple and uplifting',
              //   description: 'Zesty lime sits on a sublime grounding of sandalwood.',
              // },
            },
            {
              value: 'Lily and white rose',
              description: 'Sensual and sophisticated. Lily and white rose mix with bergamot, musk and subtle notes of amber, cedar and peony.',
              // info: {
              //   title: 'Sensual and sophisticated',
              //   description: 'Lily and white rose mix with bergamot, musk and subtle notes of amber, cedar and peony.',
              // },
            },
            {
              value: 'Musk and pear',
              description: 'Irresistibly seductive. Musk and pear mix with bergamot, heliotrope, liquorice and vanilla bean.',
              // info: {
              //   title: 'Irresistibly seductive',
              //   description: 'Musk and pear mix with bergamot, heliotrope, liquorice and vanilla bean.',
              // },
            },
            {
              value: 'Zesty tangerine guava',
              description:'Evoking a summertime beach feeling. Aquatic notes mix with zesty fruits and subtle floral notes of fresh blossoms, geranium, peony and violet.',
              // info: {
              //   title: 'Evoking a summertime beach feeling',
              //   description:'Aquatic notes mix with zesty fruits and subtle floral notes of fresh blossoms, geranium, peony and violet.',
              // },
            },
            {
              value: 'Cucumber melon',
              description: 'Clean and fruity. Melon and cucumber mix with fresh watery greens.',
              // info: {
              //   title: 'Clean and fruity',
              //   description: 'Melon and cucumber mix with fresh watery greens.',
              // },
            },
            {
              value: 'Pink champagne and exotic fruits',
              description: 'Sweet, rich and complex. Pink champagne mixes with a delicious platter of passion fruit, guava and grapefruit.',
              // info: {
              //   title: 'Sweet, rich and complex',
              //   description: 'Pink champagne mixes with a delicious platter of passion fruit, guava and grapefruit.',
              // },
            },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Learn more',
          body: (
            <>
              <p>
                All of our fragrances are manufactured in Australia and adhere to the Research Institute of Fragrance
                Materials (RIFM) and the International Fragrance Association (IFRA) standards for purity and safety.
              </p>
              <p>
                Fragrances are unfortunately common culprits for irritation, so if you're particularly sensitive, we
                recommend giving them a miss. This will decrease the likelihood of you having a reaction to your
                shampoo.
              </p>
            </>
          ),
        },
      },
      {
        heading: 'What do you want your conditioner to smell like?',
        screen: FragranceScreen,
        extraClass: 'fullwidth',

        // info: {
        //   title: null,
        //   description: 'Click on a fragrance above and learn more about it here.',
        // },
        autoSubmit: false,
        field: {
          component: FragranceGroup,
          extraClass: 'fragrance-and-colour',
          options: [
            {
              value: 'No fragrance',
              description:"We won't add fragrance to your formulations, but that doesn't mean they will smell like nothing. The other ingredients have a fairly mild smell most find inoffensive.",
              sensitive: true,
              // info: {
              //   title: null,
              //   description:
              //     "We won't add fragrance to your formulations, but that doesn't mean they will smell like nothing. The other ingredients have a fairly mild smell most find inoffensive.",
              // },
            },
            {
              value: 'Peony and suede',
              description:'Floral peony, rose and jasmine mix with subtle notes of fuji apple, honeydew, musk and amber.',
              // info: {
              //   title: 'Luxurious and sensual',
              //   description:'Floral peony, rose and jasmine mix with subtle notes of fuji apple, honeydew, musk and amber.',
              // },
            },
            {
              value: 'Florals',
              description: 'Gardenia, cyclamen and frangipani mix with subtle notes of balsam, rosewood and jasmine.',
              // info: {
              //   title: 'A tribute to all things floral',
              //   description: 'Gardenia, cyclamen and frangipani mix with subtle notes of balsam, rosewood and jasmine.',
              // },
            },
            {
              value: 'Soft florals and sweet vanilla',
              description: 'Floral rose, jasmine and hawthorn mix with sweet notes of vanilla and musk on a woody base.',
              popular: true,
              // info: {
              //   title: 'Clean and smooth',
              //   description: 'Floral rose, jasmine and hawthorn mix with sweet notes of vanilla and musk on a woody base.',
              // },
            },
            {
              value: 'Blackberry and strawberry',
              description: 'Blackberry and strawberry mix with apple, peony and white jasmine on a base of vanilla bean and precious woods.',
              popular: true,
              // info: {
              //   title: 'Fruity yet rich and compelling',
              //   description: 'Blackberry and strawberry mix with apple, peony and white jasmine on a base of vanilla bean and precious woods.',
              // },
            },
            {
              value: 'Lime and sandalwood',
              description: 'Zesty lime sits on a sublime grounding of sandalwood.',
              // info: {
              //   title: 'Simple and uplifting',
              //   description: 'Zesty lime sits on a sublime grounding of sandalwood.',
              // },
            },
            {
              value: 'Lily and white rose',
              description: 'Lily and white rose mix with bergamot, musk and subtle notes of amber, cedar and peony.',
              // info: {
              //   title: 'Sensual and sophisticated',
              //   description: 'Lily and white rose mix with bergamot, musk and subtle notes of amber, cedar and peony.',
              // },
            },
            {
              value: 'Musk and pear',
              description: 'Musk and pear mix with bergamot, heliotrope, liquorice and vanilla bean.',
              // info: {
              //   title: 'Irresistibly seductive',
              //   description: 'Musk and pear mix with bergamot, heliotrope, liquorice and vanilla bean.',
              // },
            },
            {
              value: 'Zesty tangerine guava',
              description: 'Aquatic notes mix with zesty fruits and subtle floral notes of fresh blossoms, geranium, peony and violet.',
              // info: {
              //   title: 'Evoking a summertime beach feeling',
              //   description: 'Aquatic notes mix with zesty fruits and subtle floral notes of fresh blossoms, geranium, peony and violet.',
              // },
            },
            {
              value: 'Cucumber melon',
              description: 'Melon and cucumber mix with fresh watery greens.',
              // info: {
              //   title: 'Clean and fruity',
              //   description: 'Melon and cucumber mix with fresh watery greens.',
              // },
            },
            {
              value: 'Pink champagne and exotic fruits',
              description: 'Pink champagne mixes with a delicious platter of passion fruit, guava and grapefruit.',
              // info: {
              //   title: 'Sweet, rich and complex',
              //   description: 'Pink champagne mixes with a delicious platter of passion fruit, guava and grapefruit.',
              // },
            },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Learn more',
          body: (
            <>
              <p>
                All of our fragrances are manufactured in Australia and adhere to the Research Institute of Fragrance
                Materials (RIFM) and the International Fragrance Association (IFRA) standards for purity and safety.
              </p>
              <p>
                Fragrances are unfortunately common culprits for irritation, so if you're particularly sensitive, we
                recommend giving them a miss. This will decrease the likelihood of you having a reaction to your
                conditioner.
              </p>
            </>
          ),
        },
      },
      {
        heading: 'How strong do you like your fragrance?',
        field: {
          component: ButtonGroup,
          options: [{ value: 'Light' }, { value: 'Medium' }, { value: 'Strong' }],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Have sensitivities?',
          body: (
            <p>
              If you have significant sensitivities but still want fragrance added to your shampoo and conditioner, we
              recommend you select the 'Light' option. Fragrances are unfortunately common culprits for irritation so
              lowering their concentrations will decrease the likelihood of you having problems with your shampoo and
              conditioner.
            </p>
          ),
        },
      },
      {
        heading: 'What colour do you want your shampoo to be?',
        screen: ColourScreen,
        autoSubmit: false,
        field: {
          component: ColourGroup,
          options: [
            { value: 'Brassiness pigment', hexcode: '#353C6A', img: 'shampoo/brassiness-blonde.jpg', brassiness: 'blonde' },
            { value: 'Brassiness pigment', hexcode: '#144C84', img: 'shampoo/brassiness-brunette.jpg', brassiness: 'brunette' },
            { value: 'Jarrah', hexcode: '#E8B898', img: 'shampoo/jarrah.jpg' },
            { value: 'Bottlebrush', hexcode: '#FF8485', img: 'shampoo/bottlebrush.jpg' },
            { value: 'Simpson', hexcode: '#FFA85F', img: 'shampoo/simpson.jpg' },
            { value: 'Wattle', hexcode: '#FFE597', img: 'shampoo/wattle.jpg' },
            { value: 'Daintree', hexcode: '#E3F1BD', img: 'shampoo/daintree.jpg' },
            { value: 'Bondi', hexcode: '#CDF4EA', img: 'shampoo/bondi.jpg' },
            { value: 'Jacaranda', hexcode: '#F2D0E9', img: 'shampoo/jacaranda.jpg' },
            { value: 'Hillier', hexcode: '#FEC2AA', img: 'shampoo/hillier.jpg' },
            { value: 'No colouring', hexcode: null, img: 'shampoo/no-colouring.jpg' },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Learn more',
          body: (
            <>
              <p>
                All our colouring ingredients are approved for use in cosmetics by Australia, the USA and the European
                Union.
              </p>
              <p>
                Colourings are unfortunately common culprits for irritation, so if you're particularly sensitive, we
                recommend giving them a miss. This will decrease the likelihood of you having a reaction to your
                shampoo.
              </p>
              <p>
                Our colour palette is inspired by the vibrancy of the Australian landscape. Variations in colour may
                occur due to your formulation's unique combination of ingredients and the way your screen displays
                colour. Each bottle is truly one of a kind!
              </p>
            </>
          ),
        },
      },
      {
        heading: 'What colour do you want your conditioner to be?',
        screen: ColourScreen,
        autoSubmit: false,
        field: {
          component: ColourGroup,
          options: [
            { value: 'Brassiness pigment', hexcode: '#353C6A', img: 'conditioner/brassiness-blonde.jpg', brassiness: 'blonde' },
            { value: 'Brassiness pigment', hexcode: '#144C84', img: 'conditioner/brassiness-brunette.jpg', brassiness: 'brunette' },
            { value: 'Jarrah', hexcode: '#E8B898', img: 'conditioner/jarrah.jpg' },
            { value: 'Bottlebrush', hexcode: '#FF8485', img: 'conditioner/bottlebrush.jpg' },
            { value: 'Simpson', hexcode: '#FFA85F', img: 'conditioner/simpson.jpg' },
            { value: 'Wattle', hexcode: '#FFE597', img: 'conditioner/wattle.jpg' },
            { value: 'Daintree', hexcode: '#E3F1BD', img: 'conditioner/daintree.jpg' },
            { value: 'Bondi', hexcode: '#CDF4EA', img: 'conditioner/bondi.jpg' },
            { value: 'Jacaranda', hexcode: '#F2D0E9', img: 'conditioner/jacaranda.jpg' },
            { value: 'Hillier', hexcode: '#FEC2AA', img: 'conditioner/hillier.jpg' },
            { value: 'No colouring', hexcode: null, img: 'conditioner/no-colouring.jpg' },
          ],
          rules: ['required'],
        },
        disclaimer: {
          title: 'Learn more',
          body: (
            <>
              <p>
                All our colouring ingredients are approved for use in cosmetics by Australia, the USA and the European
                Union.
              </p>
              <p>
                Colourings are unfortunately common culprits for irritation, so if you're particularly sensitive, we
                recommend giving them a miss. This will decrease the likelihood of you having a reaction to your
                conditioner.
              </p>
              <p>
                Our colour palette is inspired by the vibrancy of the Australian landscape. Variations in colour may
                occur due to your formulation's unique combination of ingredients and the way your screen displays
                colour. Each bottle is truly one of a kind!
              </p>
            </>
          ),
        },
      },
    ],
  },
  {
    name: 'Charity',
    steps: [
      {
        heading: 'Choose a charity.',
        subHeading: () => (
          <>
            We give 1% of our revenue to our charity partners and want your help deciding how it should be allocated. To
            learn more about how this works, read our{' '}
            <a className="text-secondary" href="/charitable-donations-policy/" target="_blank" rel="noopener">
              Charitable Donations Policy
            </a>
          </>
        ),
        info: {
          title: null,
          description: 'Click on a charity above and learn more about it here.',
        },
        autoSubmit: false,
        field: {
          component: ImageGroup,
          extraClass: 'choose-your-charity',
          options: [
            {
              value: 'Beyond Blue',
              svg: 'beyond-blue',
              info: {
                title: null,
                description:
                  "Beyond Blue is a safe and reliable place for millions of Australians to access information, advice and support for mental health, no matter whether they're well and want to stay that way, unwell and need support, or in recovery.",
              },
            },
            {
              value: 'Clean Up Australia Day',
              svg: 'clean-up-australia',
              info: {
                title: null,
                description:
                  "Clean Up Australia Day is our nation's largest, annual, community-based environmental event. Over three decades, Clean Up Australia has now become the country's most recognised, credible and trusted environmental charity, working towards practical solutions for our waste challenges to help us live more sustainably every day of the year.",
              },
            },
            {
              value: 'WIRES',
              svg: 'wires',
              info: {
                title: null,
                description:
                  "WIRES operate a dedicated Wildlife Rescue Office assisting wildlife and the community across Australia 24-hours a day, 365 days a year, providing rescue advice and assistance for over 130,000 animals annually. Caring for sick, injured and orphaned native animals for over 35 years, WIRES is Australia's largest wildlife rescue organisation.",
              },
            },
          ],
          rules: ['required'],
        },
      },
      {
        heading: 'Enter your email address to unlock your formulas.',
        subHeading: 'By entering your email and pressing continue, you agree to our Privacy Policy and will be added to our mailing list.',
        autoSubmit: false,
        field: {
            component: Input,
            name: 'emailsubcribe',
            type: 'email',
            label: 'Enter your email address',
            rules: ['required', 'email'],
        },
      },
    ],
  },
];
